var installedModules = {};
var moduleToHandlerMapping = {
	61473: {
		getter: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["legacy"],
		},
		shareKey: "react",
	},
	21575: {
		getter: () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["legacy"],
		},
		shareKey: "react-dom",
	},
	35258: {
		getter: () => (() => (__webpack_require__(95093))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.29.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "moment",
	},
	63351: {
		getter: () => (Promise.all([__webpack_require__.e(1376), __webpack_require__.e(7955)]).then(() => (() => (__webpack_require__(41376))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.4.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-intl",
	},
	54663: {
		getter: () => (__webpack_require__.e(2026).then(() => (() => (__webpack_require__(42026))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "reflux",
	},
	79037: {
		getter: () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.17.21",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	38815: {
		getter: () => (__webpack_require__.e(4179).then(() => (() => (__webpack_require__(24179))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.2.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"1473": [
		61473
	],
	"4675": [
		54663,
		79037
	],
	"6121": [
		21575,
		35258,
		63351
	],
	"8815": [
		38815
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}